import { ContainerModule } from "inversify";
import {
  IUserPreferencesGateway,
  UserPreferencesGatewayDi
} from "@/core/services/userPreferences/ports/UserPreferencesGateway";
import UserPreferencesGatewayAdapter from "@/core/services/userPreferences/adapters/UserPreferencesGatewayAdapter";

const userPreferencesContainer = new ContainerModule((bind) => {
  bind<IUserPreferencesGateway>(UserPreferencesGatewayDi).to(
    UserPreferencesGatewayAdapter
  );
});

export { userPreferencesContainer };
